/**
 * API Configuration
 * Switch between environments by changing the activeEnvironment
 */

export type Environment = 'local' | 'sandbox' | 'production';

interface ApiEnvironmentConfig {
  baseUrl: string;
  name: string;
}

const environments: Record<Environment, ApiEnvironmentConfig> = {
  local: {
    baseUrl: 'http://localhost:7233/api/v1',
    name: 'Local Development',
  },
  sandbox: {
    baseUrl: 'https://sandbox-application-tools-ahbag7gcc3f6asb3.centralus-01.azurewebsites.net/api/v1', // Update with your sandbox URL
    name: 'Sandbox',
  },
  production: {
    baseUrl: 'https://prod-application-tools-gwdzegbkh2ddahc8.centralus-01.azurewebsites.net/api/v1', // Update with your production URL
    name: 'Production',
  },
};

// Set the active environment here
export const activeEnvironment: Environment = 'production';

export const apiConfig = {
  ...environments[activeEnvironment],
  endpoints: {
    timeSheets: '/cw_time_sheets',
    timeEntries: '/cw_time_entries',
    workTypes: '/cw_time_work_types',
    workRoles: '/cw_time_work_roles',
    chargeCodes: '/cw_time_charge_codes',
    projectTickets: '/cw_project_tickets',
    cwUsers: '/cw_users',
    workRoleValidations: '/work_role_validations',
  },
  defaultPageSize: 1000,
};
